angular.module('lf.desktop')

.controller('CheckoutShippingCtrl', function ($scope, preloadData, checkoutService) {
  var shippingData = lf.data.checkoutData.shippingData;

  $scope.addresses = shippingData.shippingAddresses || [];
  
//  $scope.defaultAddress = $scope.addresses.filter(function (address) {
//    return address.isDefaultAddress;
//  })[0];
//  
//  $scope.selectedAddress = $scope.addresses.filter(function (address) {
//    return address.isSelected;
//  }) || $scope.defaultAddress;
  
  $scope.selectedAddress = _.where($scope.addresses, {isSelected: true})[0] ||
                           _.where($scope.addresses, {isDefault: true})[0];
  
  $scope.selectShippingAddress = function (address) {
    checkoutService.applyShippingInformation({
      shippingMethodName: address.shippingMethods[0].name,
      shippingAddressId: address.id,
      address1: address.address1, 
      address2: address.address2,
      city: address.city,
      state: address.state,
      country: address.country,
      postalCode: address.postalCode,
      verificationStatus: address.verificationStatus
    })
      .success(function (applyShippingInformationResponse) {
        if(applyShippingInformationResponse.data.success) {
          console.log("Shipping address on order was changed to (id = "+ address.id +", addressLine1 = "+ address.address1+") with shipping method ('"+address.shippingMethods[0].name +"').");
          $scope.selectedAddress = address;
          if ($scope.selectedAddress.shippingMethods && $scope.selectedAddress.shippingMethods.length) {
            $scope.selectedAddress.shippingMethods.forEach(function (method) {
              method.isSelected = false;
            });
            $scope.selectedAddress.shippingMethods[0].isSelected = true;
            $scope.selectShippingMethod($scope.selectedAddress.shippingMethods[0]);
          }
        } else {
          console.log("Error occured while applying shipping address (id = "+ address.id +", addressLine1 = "+ address.address1+") with shipping method ('"+address.shippingMethods[0].name +"') to the order.");     
        }
      })
      .error(function (applyShippingInformationResponse) {
        console.log("Error occured while applying shipping address (id = "+ address.id +", addressLine1 = "+ address.address1+") with shipping method ('"+address.shippingMethods[0].name +"') to the order.");
      });
  }
  
  $scope.getShippingMethods = function () {
    return $scope.selectedAddress && $scope.selectedAddress.shippingMethods;
  }
  
  $scope.selectShippingMethod = function (method) {
    var shippingMethods = $scope.selectedAddress.shippingMethods;
    var selectedShippingMethod = shippingMethods.filter(function (method) {
      return method.isSelected;
    })[0];
    
    if (method === selectedShippingMethod) return;
    
    checkoutService.applyShippingInformation({
      shippingMethodName: method.name,
      shippingAddressId: $scope.selectedAddress.id,
      address1: $scope.selectedAddress.address1, 
      address2: $scope.selectedAddress.address2,
      city: $scope.selectedAddress.city,
      state: $scope.selectedAddress.state,
      country: $scope.selectedAddress.country,
      postalCode: $scope.selectedAddress.postalCode,
      verificationStatus: $scope.selectedAddress.verificationStatus
    })
      .success(function (applyShippingInformationResponse) {
        if (applyShippingInformationResponse.data.success) {
          console.log('Shipping method (%s) was applied to the order.', method.name);
          shippingMethods.forEach(function (method) {
            method.isSelected = false;
          });
          method.isSelected = true;
          checkoutService.getOrderData()
            .success(function (data) {
              _.extend(lf.data.xhr.shop, data);
            });
        } else {
        console.log('Error occured while applying Shipping method (%s) to the order.', method.name);
        }
      })
      .error(function (applyShippingInformationResponse) {
        console.log('Error occured while applying Shipping method (%s) to the order.', method.name);
      });
  }
  
  var dummyNewShippingAddress = {
    firstName: 'John',
    lastName: 'Doe',
    address1: '20 st, 1',
    address2: '',
    city: 'San Francisco',
    state: 'CA',
    postalCode: '90210',
    country: 'US',
    phoneNumber: '4159009090'
  };
  
  $scope.showAddNewShippingAddressPopup = function () {
    $scope.newShippingAddress = _.clone(dummyNewShippingAddress);
    $scope.addNewShippingAddressSuggestions = null;
    $scope.popups.show('add-new-shipping-address');
  }
  
  $scope.showEditSelectedAddressPopup = function () {
    $scope.selectedAddressForm = _.clone($scope.selectedAddress);
    $scope.popups.show('edit-shipping-address');
  }
  
  $scope.updateSelectedAddress = function () {
    checkoutService.editShippingAddress($scope.selectedAddressForm)
      .success(function (res) {
        //console.log('updateSelectedAddress', res);
        var data = res.data;
        if (data.success) {
          var idx = $scope.addresses.indexOf($scope.selectedAddress);
          $scope.addresses[idx] = $scope.selectedAddressForm;
          $scope.selectedAddress = $scope.addresses[idx];
        } else {
          console.log('Error while updating address', $scope.selectedAddressForm, data);
        }
        $scope.popups.hide('edit-shipping-address');
      });
  }
  
  $scope.addNewShippingAddress = function () {
    checkoutService.addNewShippingAddress($scope.newShippingAddress)
      .success(function (res) {
        var data = res.data;
        if (data.success) {
          var idx = $scope.addresses.push($scope.newShippingAddress) - 1;
          var address = $scope.addresses[idx];
          $scope.selectedAddress = address;
          $scope.popups.hide('add-new-shipping-address');
          
          checkoutService.getShippingOptions({
            address1: address.address1,
            state: address.state,
            country: address.country,
            zipCode: address.postalCode
          })
            .success(function (data) {
              if (!data.shippingMethods || !data.shippingMethods.length) {
                console.log('Error: no shipping methods received for address', address);
                return;
              }
              // TODO: remap key-values after API `getShippingOptions`
              // update to follow latest changes
              var shippingMethods = data.shippingMethods.map(function (method) {
                return {
                  name: method.shippingMethodName,
                  amount: method.shippingAmount,
                  amountRaw: method.shippingAmountRaw,
                  description: method.shippingDescription,
                  deliveryInformation: method.deliveryInformation,
                  isSelected: false
                }
              });
              shippingMethods[0].isSelected = true;
              address.shippingMethods = shippingMethods;
            });
        } else {
          // Suggestions
          if (data.response && data.response.suggestions) {
            var suggestions = data.response.suggestions;
            if (suggestions.count) {
              $scope.addNewShippingAddressSuggestions = suggestions.data;
            }
          }
        }
      });
  }
  
  $scope.applySuggestionOnNewShippingAddress = function (suggestion) {
    var address = suggestion.address;
    $.extend($scope.newShippingAddress, {
      address1: address.street1,
      address2: address.street2,
      city: address.city,
      state: address.state,
      postalCode: address.zip
    });
    $scope.addNewShippingAddress();
  }
  
});
